import styled from "styled-components/native";
import { ScrollView } from "react-native";

export const StyledScrollView = styled(ScrollView)<{ paddingAround: boolean }>`
  flex-grow: 0;
  ${({ paddingAround }: { paddingAround: boolean }) =>
    paddingAround && "padding: 2px 0;"}
`;
